/*
 *
 * !!! DO NOT MODIFY DIRECTLY !!!
 *
 * @generated via scripts/import-icons
 *
 */

import React from 'react'

import { CssVars } from '../../../themes'
import { TextColorOverride } from '../../TextColorOverride'

export function Settings12({
  color,
}: {
  color?: React.ComponentProps<typeof TextColorOverride>['color']
}) {
  const node = (
    <svg
      fill="none"
      height="12"
      role="img"
      viewBox="0 0 12 12"
      width="12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 8.1a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2Z"
        fill={CssVars.textColor}
      />
      <path
        clipRule="evenodd"
        d="M12 4.8v2.4l-1.44.24c-.06.24-.18.54-.3.78l.84 1.2-1.68 1.68-1.2-.84c-.24.12-.48.24-.78.3L7.2 12H4.8l-.24-1.44c-.24-.06-.54-.18-.78-.3l-1.2.84L.9 9.42l.84-1.2c-.12-.24-.24-.48-.3-.78L0 7.2V4.8l1.44-.24c.06-.24.18-.54.3-.78L.9 2.58 2.58.9l1.2.84c.24-.12.54-.24.78-.3L4.8 0h2.4l.24 1.44c.24.06.54.18.78.3L9.42.9l1.68 1.68-.84 1.2c.12.24.24.48.3.78L12 4.8ZM6 9.35a3.35 3.35 0 1 0 0-6.7 3.35 3.35 0 0 0 0 6.7Z"
        fill={CssVars.textColor}
        fillRule="evenodd"
      />
    </svg>
  )
  return color ? (
    <TextColorOverride color={color}>
      {({ rootClassName }) => (
        // NOTE(jare): Since the svg node's display is "inline", it can be
        // rendered with a little whitespace around it in certain cases. We
        // wrap it in a flexbox container to remove that whitespace.
        <span className={rootClassName} css={{ display: 'inline-flex' }}>
          {node}
        </span>
      )}
    </TextColorOverride>
  ) : (
    node
  )
}
